// extracted by mini-css-extract-plugin
export default {"title":"tuto_title__UYtw9","module":"tuto_module__QHCMl","loader":"tuto_loader__xR0KF","tuto":"tuto_tuto__PGsxf","tuto__frame":"tuto_tuto__frame__0g36a"};